// Reading a stored `sent` as its provider's payload (2026-10-07). Pure, a leaf.
//
// `LeadSentFields` is a union with NO discriminant of its own — which member it
// is comes from `LeadSubmission.provider` / the route's provider. These guards
// check the SHAPE as well, so a payload read under the wrong provider is
// refused (null) rather than read as if it were the other one: a VirtualYard
// payload read as Anytime Fitness would post `undefined` fields to a club.

import type { AnytimeFitnessLeadCapture } from './anytimefitness.js';
import type { LeadSentFields, VirtualYardSentFields } from '../../types/leadRelay.js';

export function virtualYardSent(sent: LeadSentFields | null | undefined): VirtualYardSentFields | null {
  return sent && 'lid' in sent && 'interestedin' in sent ? sent : null;
}

export function anytimeFitnessSent(sent: LeadSentFields | null | undefined): AnytimeFitnessLeadCapture | null {
  return sent && 'prospectData' in sent && 'location_number' in sent ? sent : null;
}
